import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import { TextButton, IconTextButton, IconButton } from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { STATUSES, ERROR_MESSAGES, USER_ROLES, getFullUserRoleName, NUMBER_PATTERN } from "Utils/constants";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { Stack } from 'react-bootstrap';
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import { httpDownload } from "Utils/httpDownload";
import { ICONS } from "Utils/icons";
import { PATHS } from "Utils/PagePaths";

const ListPSOProfilesTable = ({ ...props }) => {
    const loginInfo = useSelector(state => state.loginInfo);
    let location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sortColumn, setSortColumn] = useState({
        sortField: "reportYear",
        sortDirection: "desc"
    });

    const [currentReportingYear, setCurrentReportingYear] = useState(0);
    const [isCurrentYearProfileExisted, setIsCurrentYearProfileExisted] = useState(null);
    const [isPSOPPCAdmin, setIsPSOPPCAdmin] = useState(null);

    const [allowCreate, setAllowCreate] = useState(null);
    const [lastYrSubmittedProfileId, setLastYrSubmittedProfileId] = useState(0);
    const [isPSO, setIsPSO] = useState(null);
    const [apiData, setApiData] = useState(null);

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
    const [feedbackCharCount, setFeedbackCharCount] = useState(0);
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const [feedbackErrors, setFeedbackErrors] = useState(null);
    const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);

    const handleDateFormat = (time) => {
        let date = new Date(time);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let min = date.getMinutes();
        return (
            <div>
                {month < 10 ? "0" + month : month}/
                {day < 10 ? "0" + day : day}/
                {year + " "}
                {hour < 10 ? "0" + hour : hour}:
                {min < 10 ? "0" + min : min}
            </div>
        )
    }

    /*
    const handleOrgNameFormat = (row) => {
      return row.psoName + " (" + row.orgPSOId + ")";
    }
    */


    const getTest = async (filter) => {
        const loginState = store.getState().loginInfo;
        var call = {
            paginationRequest: filter,
            selectedOrganizationId: 0
        };
        var url = '/api/profile/managePsoProfile';

        return http.post(url, call, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        });
    }

    function getOutput () {
        return (
            <Col className="">
                {
                    allowCreate == true && isCurrentYearProfileExisted == false
                        ? <p>Select the 'Add New PSO Profile' button to add Profile for the current reporting year.</p>
                        : null
                }
                {
                    allowCreate == true && lastYrSubmittedProfileId != null && isCurrentYearProfileExisted == false
                        ? <p>If a PSO Profile has been submitted last year, there is an opportunity to carry over the information, select the 'Carry over PSO Profile from last year' button.</p>
                        : null
                }
                {
                    allowCreate == true && isCurrentYearProfileExisted == true
                        ? <p>Select the 'Edit' link to update the current year PSO Profile.</p>
                        : null
                }
                {
                    allowCreate == true && isPSO == true
                        ? <p>Select the 'Profile Submission Feedback' button to enter your questions and feedbacks.</p>
                        : null
                }
            </Col>
        )
    }

    /* 
    const loadData = async () => {
        var filter = {
            startIndex:0,
            entryPerPage:10,
            sortingColumn:sortColumn.sortField,
            sortingOrder:sortColumn.sortDirection,
            searchTerm:""
        }
        return await getTest(filter).then((res) => {
            if(res.status!=1){
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.DATA_ERROR.title, 
                        msg: res.globalErrorMessageList[0], 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data:{}
                    }
                });
            }
            else {
                //console.log(res);
                var d = res.data;
                setCurrentReportingYear(d.currentReportingYear);
                setIsCurrentYearProfileExisted(d.currentYearProfileExisted);
                setIsPSOPPCAdmin(d.psoppcAdmin);
                setAllowCreate(d.pso);//d.setAllowCreate);

                setIsPSO(d.pso);

                setLastYrSubmittedProfileId(d.lastYrSubmittedProfileId);
            }   
        }).catch((error)=>{
             setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.DATA_ERROR.title, 
                    msg: ERROR_MESSAGES.DATA_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data:{}
                },
                error: error
            });
        });  
    };
    

    useEffect(()=>{
        //loadData();
        
    },[])
    */

    useEffect(() => {
        if (apiData != null) {
            if (apiData.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: apiData.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = apiData.data;
                setCurrentReportingYear(d.currentReportingYear);
                setIsCurrentYearProfileExisted(d.currentYearProfileExisted);
                setIsPSOPPCAdmin(d.psoppcAdmin);
                setAllowCreate(d.pso);//d.setAllowCreate);
                setIsPSO(d.pso);
                setLastYrSubmittedProfileId(d.lastYrSubmittedProfileId);
            }
        }
    }, [apiData])

    useEffect(() => {
        if (allowCreate != null && isCurrentYearProfileExisted != null && isPSO != null && lastYrSubmittedProfileId != null) {
            props.setGetButtonInstruction(getOutput());
        }

    }, [allowCreate, isCurrentYearProfileExisted, lastYrSubmittedProfileId, isPSO])

    const getListCols = (selectedList, sortingInfo) => {
        const listUserColumns = [];
        /*
        const fullNameTitle = function ({rowName}) {
            //console.log(rowName);
            return "Click the link to view PSO Profile " + rowName + ".";
        }
        */

        const profileState = function ({ rowName }) {

            return {
                state: {
                    profileId: rowName.id,
                    orgId: rowName.orgId,
                    psoppcAdmin: false
                },
                backRedirect: {
                    path: location.pathname,
                    state: location.state
                }
            };
        }

        const profileEditAdminState = function ({ rowName }) {
            return {
                state: {
                    profileId: rowName.id,
                    orgId: rowName.orgId,
                    psoppcAdmin: true
                },
                backRedirect: {
                    path: location.pathname,
                    state: location.state
                }
            };
        }

        // const getProviderReportUrl = function ({row}) {
        //     var path = row.reportYear <= 2019 ? 'psoProviderProfileReport?reportYear='+row.reportYear+'&orgId='+row.orgId+'&psoId='+row.psoId :null;
        //     return path;
        // }

        const getProviderReportEditUrl = function ({ row }) {
            var path = row.reportYear == currentReportingYear ? PATHS.private.editPSOProfile : null;
            //console.log(path);
            return path;
        }

        const getProfileViewUrl = function ({ row }) {
            var path = PATHS.private.viewPSOProfile;
            //console.log(path);
            return path;
        }

        listUserColumns.push(Datatable_Column({ name: "Report Year", columnName: "reportYear", selectedRows: selectedList, sortable: true, sortFieldNum: 4, isLink: true, linkData: { title: null, pathname: getProfileViewUrl, text: null, state: profileState }, sortingInfo: sortingInfo }))
        listUserColumns.push(Datatable_Column({ name: "PSO ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))

        listUserColumns.push(Datatable_Column({ name: "PSO Name", columnName: "orgName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listUserColumns.push(Datatable_Column({ name: "Profile Status", columnName: "statusName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))

        listUserColumns.push(Datatable_Column({ name: "User Name", columnName: ["firstName", "lastName"], concatColName: "firstName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))

        listUserColumns.push(Datatable_Column({ name: "Date", columnName: "updateDate", selectedRows: selectedList, sortable: false, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))
        listUserColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 4, isLink: true, linkData: { title: null, pathname: getProviderReportEditUrl, text: "Edit", state: isPSOPPCAdmin != true ? profileState : profileEditAdminState }, sortingInfo: sortingInfo }))

        // if(isPSOPPCAdmin===true){
        //     listUserColumns.push(Datatable_Column({name:"Provider Report", columnName:"report", selectedRows:selectedList, sortable:false, sortFieldNum:4, isLink:true, linkData:{title: null, pathname: getProviderReportUrl ,text: "Report", state:null},sortingInfo:sortingInfo}))
        // }
        //currentReportingYear
        return listUserColumns;
    }

    const tableTitle = function () {
        return "PSO Profile Activity";
    }

    const tableDescription = function () {
        return "Select a reporting year to view detailed information.";
    }
    const [selectedCount, setSelectedCount] = useState(0);

    /*
    const handleCreatePopup = (e) => {
      props.setShowPopup(true);
    }
    */

    const getDownloadCall = async () => {

        var url = '/api/report/profileDetail';
        //const loginState = store.getState().loginInfo;

        return httpDownload.post(url, { "reportYear": 0, "orgId": 0 }, {
            responseType: 'blob',
            timeout: 90000,
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const handleDetailReportDownload = async () => {
        const res = await getDownloadCall();
        if (res) {
            // get filename from the res content-disposition
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        }
    }

    const getSummaryDownloadCall = async () => {

        var url = '/api/report/profileSummary';
        //const loginState = store.getState().loginInfo;

        return httpDownload.post(url, null, {
            responseType: 'blob',
            timeout: 90000,
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const handleProfileSummaryReportDownload = async () => {
        const res = await getSummaryDownloadCall();
        if (res) {
            // get filename from the res content-disposition
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            //console.log(filename)
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        }
    }
    /*
    const errorHandle = function () {
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true, 
                title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                showContactHelp: true 
            },
            redirect: {
                redirect: false, 
                redirectFirst: false,
                path: "", 
                data: {}
            }
        })
    };
    */

    const handleCreatePSOProfile = () => {

        navigate(
            "/manage/createPSOProfile",
            {
                state: {
                    backRedirect: {
                        path: location.pathname,
                        state: location.state
                    }
                }
            }

        );
    }

    const handleCarryOver = () => {

        navigate(
            "/manage/carryOverPSOProfile",
            {
                state: {
                    backRedirect: {
                        path: location.pathname,
                        state: location.state
                    }
                }
            }

        );
    }

    const handleFeedback = () => {
        setShowFeedbackPopup(true);

    }

    const hideFeedback = () => {
        setShowFeedbackPopup(false);

        setFeedbackErrors(null);
        setFeedbackMessage('');
        setFeedbackCharCount(0);
    }

    const onFeedbackChange = (e) => {

        var content = e.target.value;
        var text = content.substring(0, 2000);
        setFeedbackErrors(null);
        setFeedbackMessage(text);
        setFeedbackCharCount(text.length);
    }

    const onSubmitFeedback = async (e) => {
        setIsFeedbackLoading(true);
        setFeedbackErrors(null);

        var url = "/api/profile/feedback";
        var values = {
            feedbackMsg: feedbackMessage
        }

        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if (response != null) {

                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    //console.log(response.globalErrorMessageList);

                    if (response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }

                    if (response.fieldErrors != null) {
                        setFeedbackErrors(response.fieldErrors.feedbackMsg.errorMessages);
                    }
                }
                else {
                    ///Thank you for your feedback!
                    if (response.fieldErrors != null && response.fieldErrors.hasOwnProperty("feedbackMsg")) {
                        setFeedbackErrors(response.fieldErrors.feedbackMsg.errorMessages);
                    }
                    else {
                        hideFeedback();

                        setGlobalSuccessStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: "Thank you!",
                                msg: "Thank you for your feedback!",
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: ""

                            }
                        });
                    }
                }

            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            setIsFeedbackLoading(false);

        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
            setIsFeedbackLoading(false);
        });
        return res;
    };

    var popupButtons = [
        {
            text: "Submit",
            action: onSubmitFeedback,
            variant: "normal",
            disabled: feedbackCharCount < 1 || isFeedbackLoading == true ? true : false
        },
        {
            text: "Cancel",
            action: hideFeedback,
            variant: "outline",
            disabled: false
        }
    ]

    var displayErrors = (errors) => {
        return (
            <div>
                {errors != null && errors.length > 0 ? errors.map((errorText, index) =>
                    <Stack key={"Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>

                ) : null}
            </div>
        );
    }

    return (
        <>
            {
                /* <DocumentTag groupId={2284} pageName="manage PSO Profile" linkTitle="linkTitleSample" linkText="linkTextSample"  errorHandle={errorHandle}></DocumentTag>
                <DocumentTag groupId={2284} pageName="manage PSO Profile"  errorHandle={errorHandle}></DocumentTag>*/
            }
            <DynamicFormPopup
                showPopup={showFeedbackPopup}
                handleClose={hideFeedback}
                buttons={popupButtons}
                title={"PSO Profile Submission Feedback"}
                variant={"blank"}
            >

                <div className="ms-4 me-4">
                    <Form>
                        <Form.Group>
                            <Form.Label htmlFor={"feedback"} >
                                Please enter your feedback:
                            </Form.Label>
                            <Form.Control
                                id="feedback"
                                as="textarea"
                                onChange={onFeedbackChange}
                                onInput={onFeedbackChange}
                                rows={10}
                                placeholder="Provide feedback for PSO Profile"
                                value={feedbackMessage}

                            >
                            </Form.Control>
                            <Form.Text className="d-flex justify-content-end mt-0 lh-sm">
                                {feedbackCharCount}/2000
                            </Form.Text>
                            <Form.Control.Feedback tabIndex={-1} className={feedbackErrors != null && feedbackErrors.length > 0 ? "is-invalid mt-0 mb-3 lh-sm" : ""} type="invalid">
                                {displayErrors(feedbackErrors)}
                            </Form.Control.Feedback>

                        </Form.Group>
                    </Form>
                </div>
            </DynamicFormPopup>

            <DatatableBase
                tableClassName="listPSOProfilesTable"
                getData={getTest}
                getListCols={getListCols}
                setSelectedCount={setSelectedCount}
                apiData={apiData}
                setApiData={setApiData}
                hasSelectableRows={false}
                searchFieldText={"Search by reporting year, PSO ID, profile status, or user name"}
                datatableHeader={tableTitle()}
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField}
                sortingOrder={sortColumn.sortDirection}
                dataPath="pageResp"
            >
                {
                    // <Col className="d-flex justify-content-end gap-4">
                    <Row className="">
                        <Col className="text-end">
                            {
                                allowCreate == true && isCurrentYearProfileExisted == false
                                    ? <TextButton onClick={handleCreatePSOProfile} variant="normal" content={"Add New PSO Profile"} className={` me-2 mt-2`} />
                                    : null
                            }
                            {
                                allowCreate == true && lastYrSubmittedProfileId != 0 && isCurrentYearProfileExisted == false
                                    ? <TextButton onClick={handleCarryOver} variant="normal" content={"Carry over PSO Profile from last year"} className={` me-2 mt-2`} />
                                    : null
                            }
                            {
                                isPSOPPCAdmin == true
                                    ?
                                    <IconTextButton className="reverse me-2 mt-2" icon={ICONS.download} onClick={handleProfileSummaryReportDownload} variant="normal" content={"Profile Summary Report"} />

                                    : null
                            }
                            {
                                isPSOPPCAdmin == true
                                    ?
                                    <IconTextButton className="reverse me-2 mt-2" icon={ICONS.download} onClick={handleDetailReportDownload} variant="normal" content={"Profile Detail Report"} />

                                    : null
                            }
                            {
                                allowCreate == true && isPSO == true
                                    ? <TextButton onClick={handleFeedback} variant="normal" content={"Profile Submission Feedback"} className={` me-2 mt-2`} />
                                    : null
                            }
                        </Col>
                    </Row>
                    // TODO!!!: Remove below  
                    //</Col>
                    // <Col className="d-flex justify-content-end gap-4">

                    //     {
                    //         allowCreate == true && isCurrentYearProfileExisted == false
                    //             ? <TextButton onClick={handleCreatePSOProfile} variant="normal" content={"Add New PSO Profile"} />
                    //             : null
                    //     }
                    //     {
                    //         allowCreate == true && lastYrSubmittedProfileId != 0 && isCurrentYearProfileExisted == false
                    //             ? <TextButton onClick={handleCarryOver} variant="normal" content={"Carry over PSO Profile from last year"} />
                    //             : null
                    //     }
                    //     {
                    //         isPSOPPCAdmin == true
                    //             ? <IconTextButton className="reverse" icon={ICONS.download} onClick={handleProfileSummaryReportDownload} variant="normal" content={"Profile Summary Report"} />
                    //             : null
                    //     }
                    //     {
                    //         isPSOPPCAdmin == true
                    //             ? <IconTextButton className="reverse" icon={ICONS.download} onClick={handleDetailReportDownload} variant="normal" content={"Profile Detail Report"} />
                    //             : null
                    //     }
                    //     {
                    //         allowCreate == true && isPSO == true
                    //             ? <TextButton onClick={handleFeedback} variant="normal" content={"Profile Submission Feedback"} />
                    //             : null
                    //     }

                    // </Col>
                }
            </DatatableBase>
        </>
    );
}

export default ListPSOProfilesTable;